const btn = document.querySelector('#btn-top-search')
const form = document.querySelector('#search-form')
const form_container = document.querySelector('#search-form-container')

if (!btn) {
  return
}

function scrollTo(offset, callback) {
  const fixedOffset = offset.toFixed()
  const onScroll = function () {
    if (window.pageYOffset.toFixed() === fixedOffset) {
      window.removeEventListener('scroll', onScroll)
      callback()
    }
  }

  window.addEventListener('scroll', onScroll)
  onScroll()
  window.scrollTo({
    top: offset,
    behavior: 'smooth',
  })
}

btn.addEventListener('click', () => toggleSearch())

function toggleSearch() {
  const hidden = form.getAttribute('aria-hidden') === 'true'
  if (hidden) {
    document.body.classList.add('overflow-hidden')
  } else {
    document.body.classList.remove('overflow-hidden')
  }
  scrollTo(0, function () {
    form.setAttribute('aria-hidden', hidden ? 'false' : 'true')
    setTimeout(() => {
      btn.setAttribute('data-mode', hidden ? 'close' : 'search')
      form.querySelector('input').focus()
    }, 100)
  })
}

// toggleSearch when click outside #search-form
form.addEventListener('click', (event) => {
  if (!event.target.closest('#search-form-container')) {
    toggleSearch()
  }
})
